import { useEffect, useState } from 'react';

/**
 * 목록 퀵 기능 버튼 (S펜 스타일 방사형 메뉴)
 */
function ButtonListFunction({
  actions = [],
  disabled = false,
  isEditing = false,
  onComplete
}) {
  const [isOpen, setIsOpen] = useState(false);

  const safeActions = actions;
  const total = safeActions.length;
  const BUTTON_SPACING = 66;
  const HORIZONTAL_OFFSET = 4;

  useEffect(() => {
    if (isEditing && isOpen) {
      setIsOpen(false);
    }
  }, [isEditing, isOpen]);

  const toggleMenu = () => {
    if (disabled || total === 0) return;
    setIsOpen((prev) => !prev);
  };

  const handleActionClick = (action) => {
    if (disabled || action?.disabled) return;
    action?.onClick?.();
    setIsOpen(false);
  };

  const computePosition = (index) => {
    if (!isOpen || total === 0) {
      return {
        transform: 'translate(-50%, -50%) translate(0px, 0px)',
        opacity: 0,
        pointerEvents: 'none'
      };
    }

    const verticalOffset = (index + 1) * BUTTON_SPACING;

    return {
      transform: `translate(calc(-50% - ${HORIZONTAL_OFFSET}px), -50%) translate(0px, -${verticalOffset}px)`,
      opacity: 1,
      pointerEvents: 'auto'
    };
  };

  return (
    <div className="fixed bottom-4 md:bottom-6 right-4 md:right-6 z-30">
      <div className="relative w-16 h-16 md:w-20 md:h-20">
        {safeActions.map((action, index) => (
          <button
            key={action.key || index}
            type="button"
            onClick={() => handleActionClick(action)}
            disabled={disabled || action.disabled}
            className={`absolute top-1/2 left-1/2 w-10 h-10 md:w-12 md:h-12 text-lg md:text-xl flex items-center justify-center rounded-full shadow-lg transition-all duration-200 ${
              action.color || 'bg-gray-700 hover:bg-gray-800'
            } ${action.disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
            style={computePosition(index)}
            title={action.title || action.label}
          >
            {action.label}
          </button>
        ))}

        <button
          type="button"
          onClick={() => {
            if (isEditing) {
              onComplete?.();
            } else {
              toggleMenu();
            }
          }}
          disabled={disabled}
          title={
            isEditing ? '완료' : 
            safeActions.length === 0 ? '기능 없음' : 
            isOpen ? '닫기' : '메뉴'
          }
          className={`absolute inset-0 w-12 h-12 md:w-14 md:h-14 m-auto rounded-full text-white font-semibold shadow-2xl transition-all duration-200 text-lg md:text-xl flex items-center justify-center ${
            disabled
              ? 'bg-gray-400 cursor-not-allowed'
              : isEditing
              ? 'bg-orange-600'
              : isOpen && safeActions.length > 0
              ? 'bg-orange-600'
              : 'bg-orange-500 hover:bg-orange-600'
          }`}
        >
          {isEditing ? '✅' : safeActions.length === 0 ? '⚠️' : isOpen ? '✕' : '☰'}
        </button>
      </div>
    </div>
  );
}

export default ButtonListFunction;

